import DashboardLayout from "@/pages/Layout/DashboardLayout";

const NotFound = () => import(/* webpackChunkName: "misc" */ "@/pages/GeneralViews/NotFoundPage.vue");

const Landing = () => import(/* webpackChunkName: "landing" */ "@/pages/GeneralViews/Landing.vue");
const AboutUs = () => import(/* webpackChunkName: "about" */ "@/pages/AboutUs.vue");
const NewsAndUpdates = () => import(/* webpackChunkName: "updates" */ "@/pages/NewsAndUpdates.vue");
const Pricing = () => import(/* webpackChunkName: "pricing" */ "@/pages/Pricing.vue");
const Features = () => import(/* webpackChunkName: "features" */ "@/pages/Features.vue");
const ContactUs = () => import(/* webpackChunkName: "contact" */ "@/pages/ContactUs.vue");
const BlogIndex = () => import(/* webpackChunkName: "blog" */ "@/pages/Blog/BlogIndex.vue");
const BlogPost = () => import(/* webpackChunkName: "blog" */ "@/pages/Blog/BlogPost.vue");
const LegalDocument = () => import(/* webpackChunkName: "legal" */ "@/pages/Legal/LegalDocument.vue");

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DashboardLayout,
    children: [
      { path: '/',         name: 'Landing',  components: { default: Landing } },
      { path: '/about',    name: 'About',    components: { default: AboutUs } },
      { path: '/contact',  name: 'Contact',  components: { default: ContactUs } },
      { path: '/updates',  name: 'Updates',  components: { default: NewsAndUpdates } },
      { path: '/pricing',  name: 'Pricing',  components: { default: Pricing } },
      { path: '/features', name: 'Features', components: { default: Features } },
      { path: '/blog',     name: 'Blog',     components: { default: BlogIndex } },
      { path: '/blog/:slug', name: 'BlogPost', components: { default: BlogPost } },
      { path: '/demo',     redirect: '/contact' },
    ]
  },
  { path: '/legal/:doc', name: 'Legal', component: LegalDocument },
  { path: '*', component: NotFound }
];

export default routes;
